<div
  class="wrapper"
  [ngClass]="{ dark: background() === 'dark', small: size() === 'small', 'no-selected': !selected() }"
  #wrapperSwitch
>
  @for (item of menu(); track item.label) {
    <div class="button" [ngClass]="{ selected: item === selected() }" (click)="setSelected(item)">
      @if (item.label) {
        <p class="label ellipsis">{{ item.label | translate }}</p>
      }
    </div>
  }
</div>
